<template> 
    <modal :open="open" @close="$emit('close')" title="Add a Content Block">

        <div class="blocks__add__block" v-bind:key="index" v-for="(block, index) in blocks" @click="addBlock(block)">
            <span><i class="material-icons">{{block.icon}}</i></span>
            <b>{{$t(block.name)}}</b>
        </div>

    </modal>
</template>

<script>
    import Modal from '@/components/Modal.vue'

    export default {
        props: ['open'],
        components: {
            Modal
        },
        data () {
            return {
                blocks: []
            }
        },
        methods: {
            addBlock (block) {
                this.$emit('close', block)
            }
        },
        mounted () {
            this.$http.get('/portfolio/theme/definition/').then(data =>{
                this.blocks = data.data.blocks
            })
        }
    }
</script>
